import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCollection = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 8.5H8V4.5H4V8.5ZM10 20.5H14V16.5H10V20.5ZM8 20.5H4V16.5H8V20.5ZM4 14.5H8V10.5H4V14.5ZM14 14.5H10V10.5H14V14.5ZM16 4.5V8.5H20V4.5H16ZM14 8.5H10V4.5H14V8.5ZM16 14.5H20V10.5H16V14.5ZM20 20.5H16V16.5H20V20.5Z",
		fill: "white"
	})
});
export { SvgCollection as ReactComponent };
